import clsx from "clsx";
import { entries } from "lodash-es";
import { useState } from "react";
import { Button } from "@/components/common";
import { InputRadio } from "@/components/common/inputs";
import { useForm } from "@/hooks/common/use-form";
import { generateOptionsFromEnum } from "@/utils";

export enum FilterType {
  ByPeriod = "Por período",
  ByYear = "Por ano",
}

export const FilterTypeTranslations: Record<FilterType, string> = {
  [FilterType.ByPeriod]: "Por período",
  [FilterType.ByYear]: "Por ano",
};

type Props = Readonly<{
  value?: number | null;
  className?: string;
  disableUnselect?: boolean;
  showYearOnly?: boolean;
  showPeriodOnly?: boolean;
  title?: string;
}>;

const shortYear = Number(new Date().getFullYear().toString().substring(2, 4));
const yearEntries = Array.from({ length: 6 }, (_, index) => new Date().getFullYear() - index).reverse();
const periodEntries = Array.from(
  { length: 6 },
  (_, index) => `Jan/${shortYear - index} - Dez/${shortYear - index}`,
).reverse();

export const FormYearOrPeriod = ({
  className,
  disableUnselect,
  showYearOnly,
  showPeriodOnly,
  title,
}: Props): JSX.Element => {
  const [selectedYear, setSelectedYear] = useState<number>();
  const [selectedPeriod, setSelectedPeriod] = useState<string>();
  const yearNameClasses =
    "block p-2 before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:content-[attr(title)]";

  const { control } = useForm({
    handleSubmit: async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return null;
    },
    fields: {
      filterType: { validation: "none" },
    },
  });

  return (
    <div className={clsx("flex flex-col gap-4 p-6", className)}>
      <h3>{title}</h3>
      {!showYearOnly && !showPeriodOnly ? (
        <InputRadio
          className="flex-row"
          field="filterType"
          control={control}
          options={generateOptionsFromEnum(FilterTypeTranslations)}
        />
      ) : (
        <></>
      )}
      {control.getValue("filterType") === FilterType.ByPeriod ? (
        <div className="my-10 grid grid-cols-3 gap-x-2 gap-y-6">
          {entries(periodEntries).map(([_, period]) => (
            <button
              type="button"
              key={period}
              className={clsx("rounded-md border-2", {
                "border-gradient-primary !border-2 font-bold text-primary": period === selectedPeriod,
                "border-transparent ring-1 ring-inset ring-input-border": period !== selectedPeriod,
                "pointer-events-none": period === selectedPeriod && disableUnselect,
              })}
              onClick={() => {
                setSelectedPeriod(period);
              }}
            >
              <span title={period} className={clsx(yearNameClasses, "hidden min-w-24 sm:block")}>
                {period}
              </span>
              <span title={period} className={clsx(yearNameClasses, "min-w-24 px-4 sm:hidden")}>
                {period}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <div className="my-10 grid grid-cols-3 gap-x-2 gap-y-6">
          {entries(yearEntries).map(([_, year]) => (
            <button
              type="button"
              key={year}
              className={clsx("rounded-md border-2", {
                "border-gradient-primary !border-2 font-bold text-primary": year === selectedYear,
                "border-transparent ring-1 ring-inset ring-input-border": year !== selectedYear,
                "pointer-events-none": year === selectedYear && disableUnselect,
              })}
              onClick={() => {
                setSelectedYear(year);
              }}
            >
              <span title={year.toString()} className={clsx(yearNameClasses, "hidden min-w-24 sm:block")}>
                {year}
              </span>
              <span title={year.toString()} className={clsx(yearNameClasses, "min-w-24 px-4 sm:hidden")}>
                {year}
              </span>
            </button>
          ))}
        </div>
      )}
      <Button
        onClick={() => {
          control.getValue("filterType") === FilterType.ByPeriod
            ? console.log(selectedPeriod)
            : console.log(selectedYear);
        }}
        className="!max-w-full"
      >
        Filtrar
      </Button>
    </div>
  );
};
